 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"78f98a70e4585e45b14f10ffd3e3877da686a870","3":"24f762ff74bef3f89bdf280db69ce64de42ea7dc","4":"5fcd5e32","5":"e342545e10b6db7bfec3761bcb0053694b81a287","6":"7ffe3c402bbf110ca1ad6adf907c0ed43c140114","7":"61a73ce27bf9091f56602bf7b17db2dc0c60fc9d","8":"620519dd496083bc2cc757ac19ebaa1cc72a05cd","12":"component---src-pages-404-js","13":"component---src-pages-amritseries-index-js","14":"component---src-pages-blog-index-js","15":"component---src-pages-contact-examples-js","16":"component---src-pages-contact-file-upload-js","17":"component---src-pages-contact-index-js","18":"component---src-pages-contact-thanks-js","19":"component---src-pages-project-index-js","20":"component---src-pages-tags-index-js","21":"component---src-templates-blog-post-js","22":"component---src-templates-c-4-gt-page-js","23":"component---src-templates-careers-page-js","24":"component---src-templates-case-study-js","25":"component---src-templates-footer-page-js","26":"component---src-templates-frameworks-page-js","27":"component---src-templates-index-page-js","28":"component---src-templates-joinus-page-js","29":"component---src-templates-ksk-js","30":"component---src-templates-media-page-js","31":"component---src-templates-media-post-js","32":"component---src-templates-old-case-study-js","33":"component---src-templates-partners-page-js","34":"component---src-templates-product-page-js","35":"component---src-templates-project-domain-post-js","36":"component---src-templates-project-post-js","37":"component---src-templates-sushasan-page-js","38":"component---src-templates-team-page-js","39":"component---src-templates-tgc-page-js"}[chunkId]||chunkId) + "-" + {"0":"6e9c28bd4dbd458bc11a","1":"29147cbc04bbc833f6a0","2":"c9e8ef0c28204636c19d","3":"69c7854b2f897a82eaae","4":"0760523b950de90564ad","5":"122c7e64a265cf26f555","6":"6eff07e948fa3da3dcb4","7":"9a07bccce784b0ed783f","8":"765d8688fad6f8b304f6","12":"79c9868e380d8e8781e1","13":"fc5baef2e5f2aa30dfe1","14":"ef208284e7da7b56afdd","15":"c2be256b36bc52c9c1a4","16":"f794bb411bb5d8b79a36","17":"4de51c97d1b66870f01d","18":"861db6813bb3ea89afd5","19":"e629be2ecbbd2737013f","20":"4f57e100648d9c00062b","21":"4297882197ad3325d24b","22":"3a81b2dba86576eb5cd7","23":"cb4f38fb3db9866d42c3","24":"69c370948a7107766ba9","25":"1aa62a41c4c9902a6f28","26":"6273956a19af4b7e583f","27":"1e5ef9ce3921ec88343f","28":"4015cbc44f1f5bb1f7e4","29":"bb74ca931a1b6106187e","30":"4fc577f94d2185a986ba","31":"c68785c7cc8ad062b885","32":"59115fc1090734152152","33":"08068c1be539873c473b","34":"516d6532394a64a479f5","35":"fed1a6c310f9df5500f8","36":"27e097537e2513c78d1e","37":"c8e1829ad9a3ddf507f6","38":"9ab6c074d07b72209abc","39":"604e0b7e62b4ea95d59e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"78f98a70e4585e45b14f10ffd3e3877da686a870","3":"24f762ff74bef3f89bdf280db69ce64de42ea7dc","4":"5fcd5e32","5":"e342545e10b6db7bfec3761bcb0053694b81a287","6":"7ffe3c402bbf110ca1ad6adf907c0ed43c140114","7":"61a73ce27bf9091f56602bf7b17db2dc0c60fc9d","8":"620519dd496083bc2cc757ac19ebaa1cc72a05cd","12":"component---src-pages-404-js","13":"component---src-pages-amritseries-index-js","14":"component---src-pages-blog-index-js","15":"component---src-pages-contact-examples-js","16":"component---src-pages-contact-file-upload-js","17":"component---src-pages-contact-index-js","18":"component---src-pages-contact-thanks-js","19":"component---src-pages-project-index-js","20":"component---src-pages-tags-index-js","21":"component---src-templates-blog-post-js","22":"component---src-templates-c-4-gt-page-js","23":"component---src-templates-careers-page-js","24":"component---src-templates-case-study-js","25":"component---src-templates-footer-page-js","26":"component---src-templates-frameworks-page-js","27":"component---src-templates-index-page-js","28":"component---src-templates-joinus-page-js","29":"component---src-templates-ksk-js","30":"component---src-templates-media-page-js","31":"component---src-templates-media-post-js","32":"component---src-templates-old-case-study-js","33":"component---src-templates-partners-page-js","34":"component---src-templates-product-page-js","35":"component---src-templates-project-domain-post-js","36":"component---src-templates-project-post-js","37":"component---src-templates-sushasan-page-js","38":"component---src-templates-team-page-js","39":"component---src-templates-tgc-page-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"042c97c3ee4bf55d427a","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
